import React from "react";
import { ContextLanguage } from "../../context/Context.Language";
import { SYMBOL_CURRENCY } from "../../utils/useConstants";
import { STATE_CONSTANTS_PROGRAM } from "../../utils/useConstantState";

import { ICON_INFO } from "../../utils/useIcons";
import { useIsMobile } from "../../utils/useIsMobile";
import {
  STYLE_BODY_2_SEMIBOLD_SM,
  STYLE_BODY_2_SEMIBOLD_SM_TH,
  STYLE_DETAIl_SIZE_PRICE,
  STYLE_FLEX_INFO,
  STYLE_HOVER_BLUE,
  STYLE_IOCN_INFO_TAB,
  STYLE_PRICE_SIZE,
  STYLE_SIZE_BUTTON_MYDRY,
  STYLE_SIZE_BUTTON_MYIRON,
  STYLE_SIZE_BUTTON_MYSHOES,
  STYLE_SIZE_BUTTON_MYWASH,
  STYLE_SIZE_INACTIVE_MYDRY,
  STYLE_SIZE_INACTIVE_MYIRON,
  STYLE_SIZE_INACTIVE_MYSHOES,
  STYLE_SIZE_INACTIVE_MYWASH,
  STYLE_TAB_SIZE,
  STYLE_TEXT_SIZE_SMALL,
} from "../../utils/useStyle";

const getStyle = (type, language) => {
  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
    return STYLE_SIZE_BUTTON_MYWASH(language);
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_IRON) {
    return STYLE_SIZE_BUTTON_MYIRON(language);
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_DRY)
    return STYLE_SIZE_BUTTON_MYDRY(language);
  else if (type === STATE_CONSTANTS_PROGRAM.MY_SHOE) {
    return STYLE_SIZE_BUTTON_MYSHOES(language);
  }
};

const InactiveStyle = (type, language) => {
  if (type === STATE_CONSTANTS_PROGRAM.MY_WASH) {
    return STYLE_SIZE_INACTIVE_MYWASH(language);
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_IRON) {
    return STYLE_SIZE_INACTIVE_MYIRON(language);
  } else if (type === STATE_CONSTANTS_PROGRAM.MY_DRY)
    return STYLE_SIZE_INACTIVE_MYDRY(language);
  else if (type === STATE_CONSTANTS_PROGRAM.MY_SHOE) {
    return STYLE_SIZE_INACTIVE_MYSHOES(language);
  }
};

const TabSize = ({ value, setValue, tab = [], type, setOpen }) => {
  const { language } = React.useContext(ContextLanguage);
  const isMobile = useIsMobile();

  console.log("tab", tab);

  if (tab?.length > 0) {
    return (
      <div>
        <div
          // style={{
          //   display: "grid",
          //   gridTemplateColumns:
          //     tab?.length > 0 ? tab?.map(() => "1fr ") : " 1fr ",
          // }}

          style={{
            display: "grid",
            gridTemplateColumns:
              tab?.length === 3 ? "1fr 1fr 1fr" : "1fr 1fr 1fr 1fr 1fr",
          }}
          className={`border border-laudry-stroke rounded-full px-1 items-center text-center h-creatorder_navbar my-4`}
        >
          {tab
            ?.sort((a, b) => {
              return a?.amount - b?.amount;
            })
            ?.map((item, index) => {
              return (
                <div key={`key-of-tab-${index}`} className=" cursor-pointer ">
                  <div
                    onClick={() => {
                      if (value?.size === item?.size) {
                        // setValue("");
                        return;
                      } else {
                        setValue(item);
                      }
                    }}
                  >
                    <div
                      className={`${
                        value?.size === item?.size
                          ? getStyle(type, language)
                          : InactiveStyle(type, language)
                      }  ${
                        language === "TH"
                          ? " font-NotoSansThai "
                          : " font-Poppins "
                      }`}
                    >
                      <React.Fragment>
                        {item?.amount}{" "}
                        {!isMobile && (
                          <React.Fragment>
                            {language === "TH" ? item?.unit_th : item?.unit}
                          </React.Fragment>
                        )}
                        {/* {language === "TH" ? item?.unit_th : item?.unit} */}
                      </React.Fragment>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
        {tab?.map((item, index) => {
          if (value?.size === item?.size) {
            return (
              <div
                key={`key-of-value-${index}`}
                className={STYLE_DETAIl_SIZE_PRICE(language)}
              >
                <div
                  className={`${
                    language === "TH"
                      ? STYLE_BODY_2_SEMIBOLD_SM_TH
                      : STYLE_BODY_2_SEMIBOLD_SM
                  } text-laundry-gray-100 underline <24>`}
                >
                  {item?.name}
                </div>

                <div className={STYLE_FLEX_INFO}>
                  <div className={STYLE_PRICE_SIZE(language)}>
                    {SYMBOL_CURRENCY}
                    {item?.price}
                  </div>{" "}
                  <ICON_INFO
                    className={`${STYLE_IOCN_INFO_TAB} ${STYLE_HOVER_BLUE}`}
                    onClick={() => setOpen(true)}
                  />
                </div>
                <div
                  className={` ${STYLE_TEXT_SIZE_SMALL(
                    language
                  )} text-laundry-gray-80 text-center font-normal mt-1 md:mt-3 leading-5 `}
                >
                  {item?.description}
                </div>
              </div>
            );
          } else {
            return "";
          }
        })}
      </div>
    );
  } else {
    return <div className={`${isMobile ? " h-[42px] " : " h-[163px] "}`}></div>;
  }
};
export default TabSize;
